export const getParams = () => {
  const paramsEON = new URLSearchParams(document.location.search);
  return {
    dentalNotation: paramsEON.get("dn") || "universal",
    treatmentSetupsId: paramsEON.get("treatmentSetupsId"),
    isPatient: paramsEON.get("isPatient"), // sharable link
    tdms: paramsEON.get("tdms") || false,
    withPatientInfo: paramsEON.get("withPatientInfo") || false,
    isC: paramsEON.get("isC") || false, // converter
    lang: paramsEON.get("lang") || "en",
  };
};
